import * as API from '@/services/API';
import store from '@/store';

export default {
    index () {
        return API.apiClient.get('/survey');
    },
    getQuestions () {
        return API.apiClient.get('/survey/questions');
    },
    updateSurvey (payload) {
        return API.apiClient.put('/user/survey', payload);
    },
    storeSurvey (id, payload) {
        return API.apiClient.post(`/user/survey/${id}`, payload);
    },
    getResults () {
        return API.apiClient.get('/user/survey/results');
    },
    getResult (id) {
        return API.apiClient.get(`/user/survey/results/${id}`);
    },
    getReports () {
        return API.apiClient.get('/survey/reports');
    },
    getReport (id) {
        return API.apiClient.get(`/survey/reports/${id}`);
    }
};
